export const COMPANY = {
  name: "Tavas Infradevelopers",
  legal: "Tavas Infradevelopers Pvt. Ltd.",
  tagline: "Precision Injection Moulding",
  est: "Precision Moulding Co.",
  phone: "+91 96285 96974",
  email: "tavasinfradevelopers@gmail.com",
  address: "E-26, IIDC, UPSIDA, Kursi Rd, Barabanki 225302",
  hours: "Mon – Sat · 09:00 – 18:00 IST",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1717386255773-1e3037c81788?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxpbmplY3Rpb24lMjBtb2xkaW5nJTIwbWFjaGluZSUyMGZhY3RvcnklMjBmbG9vcnxlbnwwfHx8fDE3ODU1MjcxNzZ8MA&ixlib=rb-4.1.0&q=85",
  machine: "https://images.unsplash.com/photo-1716191300020-b52dec5b70a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxpbmplY3Rpb24lMjBtb2xkaW5nJTIwbWFjaGluZSUyMGZhY3RvcnklMjBmbG9vcnxlbnwwfHx8fDE3ODU1MjcxNzZ8MA&ixlib=rb-4.1.0&q=85",
  food: "https://images.unsplash.com/photo-1745195661755-5e781fea910f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHx0aGluJTIwcGxhc3RpYyUyMGZvb2QlMjBwYWNrYWdpbmclMjBjb250YWluZXJzfGVufDB8fHx8MTc4NTUyNzE3N3ww&ixlib=rb-4.1.0&q=85",
  automotive: "https://images.unsplash.com/photo-1625465838249-1afc776f7138?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxhdXRvbW90aXZlJTIwZWxlY3Ryb25pYyUyMHBsYXN0aWMlMjBwYXJ0c3xlbnwwfHx8fDE3ODU1MjcxNzd8MA&ixlib=rb-4.1.0&q=85",
  cosmetic: "https://images.unsplash.com/photo-1632452479455-e3d5e3159b63?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHw0fHxjb3NtZXRpYyUyMHBsYXN0aWMlMjBqYXIlMjBwYWNrYWdpbmd8ZW58MHx8fHwxNzg1NTI3MTc3fDA&ixlib=rb-4.1.0&q=85",
  electronics: "https://images.unsplash.com/photo-1601737487795-dab272f52420?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  blueprint: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const CHAPTERS = [
  {
    n: "01",
    title: "Thin-wall food packaging, engineered to the micron.",
    body: "Our core discipline. High-cavitation moulds and rapid cycle times produce lightweight, food-grade containers with consistent wall thickness and flawless stacking geometry — at scale.",
  },
  {
    n: "02",
    title: "One capability, many industries.",
    body: "The same precision that shapes a yoghurt cup shapes a cosmetic closure, an automotive clip, or an electronic housing. We are expanding our portfolio to partner with brands far beyond food.",
  },
  {
    n: "03",
    title: "Job production & custom moulding on demand.",
    body: "Bring us a drawing, a sample, or just a problem. We handle tooling, material selection, and full-run production — turning your concept into a repeatable, tolerance-held plastic part.",
  },
];

export const INDUSTRIES = [
  {
    key: "food",
    label: "Food Packaging",
    desc: "Thin-wall containers, lids & cups. Food-grade, stackable, high-volume.",
    tag: "NOW PRODUCING",
    span: "lg:col-span-8",
    img: IMAGES.food,
  },
  {
    key: "cosmetic",
    label: "Cosmetics",
    desc: "Jars, caps & closures with premium finish tolerances.",
    tag: "EXPANDING",
    span: "lg:col-span-4",
    img: IMAGES.cosmetic,
  },
  {
    key: "automotive",
    label: "Automotive",
    desc: "Clips, housings & functional components built to spec.",
    tag: "EXPANDING",
    span: "lg:col-span-4",
    img: IMAGES.automotive,
  },
  {
    key: "electronics",
    label: "Electronics",
    desc: "Enclosures & precision housings with tight fit and repeatability.",
    tag: "EXPANDING",
    span: "lg:col-span-8",
    img: IMAGES.electronics,
  },
];

export const CAPABILITIES = [
  { k: "Tooling & Mould Design", v: "In-house tooling support for single & multi-cavity moulds." },
  { k: "Material Selection", v: "PP, PET, HDPE, ABS, PC & engineering-grade polymers." },
  { k: "High-Cavitation Runs", v: "Rapid-cycle production for high-volume packaging." },
  { k: "Custom / Job Moulding", v: "Prototype to full-run production from your drawing." },
  { k: "Quality Control", v: "Dimensional checks & consistency across every batch." },
  { k: "Assembly & Finishing", v: "Secondary operations and value-added packing." },
];

export const STATS = [
  { value: "18M+", label: "Units moulded / month" },
  { value: "±0.02", label: "mm tolerance held" },
  { value: "4+", label: "Industries served" },
  { value: "100%", label: "Food-grade compliant" },
];

export const MARQUEE = [
  "INJECTION MOULDING",
  "THIN-WALL PACKAGING",
  "CUSTOM JOB PRODUCTION",
  "HIGH TOLERANCE",
  "TOYO MACHINERY",
  "FOOD GRADE",
  "COSMETICS",
  "AUTOMOTIVE",
  "ELECTRONICS",
];

export const INDUSTRY_OPTIONS = [
  "Food Packaging",
  "Cosmetics",
  "Automotive",
  "Electronics",
  "Custom / Job Moulding",
  "Other",
];
